import MoreHorizIcon from '@mui/icons-material/MoreHoriz'
import { IconButton, Menu, MenuItem } from '@mui/material'
import React, { FC, MouseEvent, useState } from 'react'
import { useParams } from 'react-router-dom'

import useAccessTokenAndShopId from '../../hooks/useAccessTokenAndShopId/useAccessTokenAndShopId'
import { useGetRepairOrdersQuery } from '../../redux/api'
import DeleteDialog from './DeleteDialog'

const AdvancedOptionsMenu: FC = () => {
  const { id } = useParams()
  const { accessToken, shopId } = useAccessTokenAndShopId()
  const { data: repairOrderList } = useGetRepairOrdersQuery({
    authorization: accessToken,
    shop: shopId,
    repairOrder: [id!]
  })

  const [menuAnchor, setMenuAnchor] = useState<HTMLElement | null>(null)
  const menuOpen = Boolean(menuAnchor)
  const [dialogOpen, setDialogOpen] = useState<boolean>(false)

  const onClose = () => setDialogOpen(false)

  const repairOrder =
    repairOrderList && repairOrderList.length > 0 && repairOrderList[0]

  const handleDeleteClick = () => {
    setDialogOpen(true)
    setMenuAnchor(null)
  }

  return (
    <>
      {repairOrder && (
        <>
          <DeleteDialog open={dialogOpen} onClose={onClose} />
          <IconButton
            data-testid="MoreButton"
            onClick={(event: MouseEvent<HTMLElement>) => {
              setMenuAnchor(event.currentTarget)
            }}>
            <MoreHorizIcon />
          </IconButton>
          <Menu
            open={menuOpen}
            anchorEl={menuAnchor}
            onClose={() => setMenuAnchor(null)}>
            <MenuItem onClick={handleDeleteClick}>
              {repairOrder.entry!.info!.archived ? 'Undelete' : 'Delete'}
            </MenuItem>
          </Menu>
        </>
      )}
    </>
  )
}

export default AdvancedOptionsMenu
